export function PeptideStructure() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg">
      {/* Background */}
      <rect width="400" height="300" fill="none" />
      
      {/* Peptide backbone */}
      <path 
        d="M50,150 C70,120 90,180 110,150 C130,120 150,180 170,150 C190,120 210,180 230,150 C250,120 270,180 290,150 C310,120 330,180 350,150" 
        stroke="#3498DB" 
        strokeWidth="4" 
        fill="none" 
      />
      
      {/* Amino acid residues */}
      <g>
        {/* Residue 1 */}
        <circle cx="70" cy="120" r="15" fill="#2C3E50" />
        <text x="70" y="123" textAnchor="middle" fill="white" fontSize="12">R1</text>
      </g>
      
      <g>
        {/* Residue 2 */}
        <circle cx="130" cy="120" r="15" fill="#E74C3C" />
        <text x="130" y="123" textAnchor="middle" fill="white" fontSize="12">R2</text>
      </g>
      
      <g>
        {/* Residue 3 */}
        <circle cx="190" cy="120" r="15" fill="#2ECC71" />
        <text x="190" y="123" textAnchor="middle" fill="white" fontSize="12">R3</text>
      </g>
      
      <g>
        {/* Residue 4 */}
        <circle cx="250" cy="120" r="15" fill="#F39C12" />
        <text x="250" y="123" textAnchor="middle" fill="white" fontSize="12">R4</text>
      </g>
      
      <g>
        {/* Residue 5 */}
        <circle cx="310" cy="120" r="15" fill="#8E44AD" />
        <text x="310" y="123" textAnchor="middle" fill="white" fontSize="12">R5</text>
      </g>
      
      {/* Peptide bonds */}
      <g>
        <circle cx="100" cy="150" r="10" fill="#3498DB" />
        <text x="100" y="153" textAnchor="middle" fill="white" fontSize="8">C=O</text>
      </g>
      
      <g>
        <circle cx="160" cy="150" r="10" fill="#3498DB" />
        <text x="160" y="153" textAnchor="middle" fill="white" fontSize="8">C=O</text>
      </g>
      
      <g>
        <circle cx="220" cy="150" r="10" fill="#3498DB" />
        <text x="220" y="153" textAnchor="middle" fill="white" fontSize="8">C=O</text>
      </g>
      
      <g>
        <circle cx="280" cy="150" r="10" fill="#3498DB" />
        <text x="280" y="153" textAnchor="middle" fill="white" fontSize="8">C=O</text>
      </g>
      
      {/* N-terminus and C-terminus indicators */}
      <text x="40" y="150" textAnchor="end" fill="#3498DB" fontWeight="bold">N</text>
      <text x="360" y="150" textAnchor="start" fill="#3498DB" fontWeight="bold">C</text>
      
      {/* Labels */}
      <text x="200" y="200" textAnchor="middle" fill="#2C3E50" fontWeight="bold" fontSize="16">
        Primary Peptide Structure
      </text>
      <text x="200" y="220" textAnchor="middle" fill="#7F8C8D" fontSize="12">
        Amino acid sequence linked by peptide bonds
      </text>
    </svg>
  );
}
